// extracted by mini-css-extract-plugin
export default {"default":"VariableManagement_default__ZOJg9"};